import { User } from 'lib-shared-types-api';

import type { PhoneNumber } from 'apis/numbers';
import type { AudioFileT } from 'components/shared/audio/api/types';

import { FlowCallFlowT } from '../api/types';

export enum LanguageCode {
  ARB = 'arb',
  CMN_CN = 'cmn-cn',
  CS_CZ = 'cs-cz',
  DA_DK = 'da-dk',
  DE_DE = 'de-de',
  EN_GB = 'en-gb',
  EN_US = 'en-us',
  ES_ES = 'es-es',
  ET_EE = 'et-ee',
  FR_FR = 'fr-fr',
  IS_IS = 'is-is',
  IT_IT = 'it-it',
  JA_JP = 'ja-jp',
  KO_KR = 'ko-kr',
  LT_LT = 'lt-lt',
  LV_LV = 'lv-lv',
  NB_NO = 'nb-no',
  NL_NL = 'nl-nl',
  PL_PL = 'pl-pl',
  PT_PT = 'pt-pt',
  RO_RO = 'ro-ro',
  RU_RU = 'ru-ru',
  SV_SE = 'sv-se',
  TR_TR = 'tr-tr',
  FI_FI = 'fi-fi',
  YUE_CN = 'yue-cn',
}

export enum Gender {
  Female = 'female',
  Male = 'male',
}

export enum CallPattern {
  FirstToPickUp = 'first_to_pick_up',
  Sequence = 'sequence',
}

export type LanguagesT = Partial<Record<LanguageCode, Gender[]>>;

export type AnnouncementT = {
  created_at: string;
  created_by: User;
  pretty_name: string;
  resource_type: string;
  url: string;
};

export type AnnouncementPayloadT = {
  file: null | AudioFileT;
  tts?: null | string;
};

export type UpdateAnnouncementPayloadT = {
  filename: string;
  url: string;
};

export type PhoneNumberItemT = {
  flows: FlowCallFlowT[];
  location: string;
  phoneNumber: PhoneNumber;
};
